export type RaterDetails = {
    formMasterName: string;
    instrumentKey: number;
    raterName: string;
    raterEmail: string;
    raterImKey: number;
    participant_ESI_Key: string;
    participantName: string;
    participantEmail: string;
    eSI_Reg_Status: number;
    raterTypeName: string;
    raterTypeKey: number;
    language: string;
    languageKey: number;
    bpiasT_Name: string;
    eFA_Key: number;
    formActualKey: number;
    rM_Key: number;
    rM_SubmittedDate: Date | null;
    surveyStatusId: number;
    statusTypeId: number;
    surveyId: string;
    formActualScoredInd: number;
};

export type RaterType = {
    raterTypeId: number;
    name: string;
};

export type DeleteRaterRequest = {
    rmkey: number;
    esiKey: number;
    esKey: number;
};

export type RaterSwitchRequest = {
    rmkey: number;
    raterTypeKey: number;
    formActualID: number;
    esiKey: number;
    esKey: number;
};

export enum EmailType {
    RegistrationConfirmation = 1,
    ParticipantInvitation = 2,
    ParticipantReminder1 = 3,
    ParticipantReminder2 = 4,
    RaterInvitation = 5,
    RaterReminder = 6,
    RegistrationConfirmationIasOE = 7,
    GlpParticipantInvitation = 10,
    GlpParticipantReminder = 11,
    CnxParticipantInvitation = 12,
    CnxParticipantReminder = 13,
    ProductParticipantInvitation = 10001,
    ProductParticipantReminder = 10002,
    ProductParticipantSelfOnlyInvitation = 10003,
    ProductParticipantSelfOnlyReminder = 10004,
    ProductRaterInvitation = 11001,
}

export type EmailRequest = {
    ParticipantId: string;
    RaterId: Number;
    EmailTypeId: EmailType;
    EmailDateToSend: Date;
};

export type AddRaterRequest = {
    participantId: number;
    instrumentId: number;
    firstName: string;
    lastName: string;
    email: string;
    raterTypeId: number;
    languageId: number;
};

export type AddRaterResult = {
    status: number;
    email: string;
};

export type LanguageList = {
    languageId: number;
    name: string;
};

export type LanguageRequest = {
    Instrument: number;
    PreferredLanguageId: number;
};

export type SearchRaters = {
    email: string;
};

export type Individual = {
    individualId: number;
    firstName: string;
    lastName: string;
    email: string;
    preferredLanguageId: string;
    preferredLanguageName: string;
};

export type AssessmentItem = {
    buildPlanId: number;
    assessmentId: number;
    participantId: number;
    instrumentId: number;
    instrumentName: string;
    instrumentTypeId: number;
    instrumentTypeName: string;
};

export type InventoryDetail = {
    aagKey: number;
    aagName: string;
    partNumber: number;
    formMasterKey: number;
    instrumentName: string;
    orderQty: number;
    availableQty: number;
    reservedQty: number;
    projectedAvailable: number;
};

export type InventoryOrder = {
    epicorOrderId: string;
    iappsOrderNumber?: number;
    displayOrderId: string;
    orderTag?: string;
    instrumentName: string;
    availableQty: number;
    formMasterKey: number;
    aagKey: number;
    placedBy?: string;
    orderDate?: string;
    orderQty?: number;
};

export type InventoryOrderDetail = {
    esKey: number;
    programTitle: string;
    startDate?: Date;
    participantEsiKey: number;
    participantImKey: number;
    participantName: string;
    participantEmail: string;
    registrationStatus: string;
    registrationStatusId: number;
    registrationDate?: Date;
    language: string;
    invitationScheduledDate?: Date;
    invitationSentDate?: Date;
    assessmentCompletionDate?: Date;
    accessExpirationDate?: Date;
};

export type ReportOptionItem = {
    reportOptionId: number;
    reportOptionValue: string;
    reportOptionDescription: string;
    reportOptionGenericDescription: string;
    scoreReportOptionTypeMapperId: number;
    isBioRescore: boolean;
};

export type ReportOptionGroup = {
    scoreReportId: number;
    scoreReportOptionTypeId: number;
    name: string;
    defaultValue: string;
    required: boolean;
    display: string;
    reportOptionItems: ReportOptionItem[];
};

export type ReportOptionsResponse = {
    instrumentId: number;
    reportOptions: ReportOptionGroup[];
};

export type SelectedReportOption = {
    scoreReportOptionTypeId: number;
    value: string;
};

export type ScoringRequestForm = { formActualId: number; raterTypeId: number; include: boolean };

export type ScoringRequestReportOption = {
    reportOptionId: number;
    value: string;
    description: string;
    scoreReportOptionTypeMapperId: number;
    isBioRescore: boolean;
    genericDescription: string;
};

export type ScoringRequestItem = {
    programId: number;
    participantId: number;
    instrumentId: number;
    individualId: number;
    vendorId: number;
    scoreReportId: number;
    englishCopy: boolean;
    requestedBy: string;
    reportOptions: ScoringRequestReportOption[];
    forms: ScoringRequestForm[];
};

export type BatchScoringRequestPayload = {
    esKey: number;
    instrumentId: number;
    englishCopy: boolean;
    esiKeys: number[];
    selectedOptions?: SelectedReportOption[];
    facilitatorImKey: number;
};

export type BatchScoringRequest = {
    batchRequest: BatchScoringRequestPayload;
};

export type FailedScoringRequestItem = {
    participantId: number;
    instrumentId: number;
    errorMessage: string;
};

export type BatchScoringRequestResult = {
    message: string;
    programId: number;
};

export type VerifyFacilitatorRequest = {
    email: string;
    instrumentKey: number;
};

export type VerifyFacilitatorResult = {
    imKey: number;
    firstName: string;
    lastName: string;
    email: string;
    c3ContactId: string;
};

export type DocumentItem = {
    documentId: number;
    documentName: string;
    assetKey: string;
    active: boolean;
    uploadedBy: string;
    uploadedDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
};

export type FinalizedChunkedDocumentUploadRequest = {
    id: string;
    fileName: string;
    contentType: string;
    chunkCount: number;
};

export type DocumentUploadResponse = {
    document?: DocumentItem;
    success: boolean;
};

export type UpdateDocumentRequest = {
    documentId: number;
    body: UpdateDocumentRequestBody;
};

export type UpdateDocumentRequestBody = {
    newDocumentName: string;
};

export type AssessmentAdminGroup = {
    groupId: number;
    groupName: string;
};

export type AssessmentAdminGroupDetail = {
    aagKey: number;
    aagName: string;
    aagDescription?: string;
    aagGroupAdminImKey?: number;
    groupAdminFirstName?: string;
    groupAdminLastName?: string;
    groupAdminEmail?: string;
    groupType: string;
    memberCount: number;
    createdByDateTime: string;
    createdByUserName: string;
    lastModifiedByDateTime: string;
    lastModifiedByUserName: string;
};

export type AssessmentAdmin = {
    aagiKey: number;
    imKey: number;
    firstName: string;
    lastName: string;
    fullName: string;
    email?: string;
    aagKey: number;
    groupName: string;
};

export type CreateGroupRequest = {
    name: string;
    description?: string;
    groupAdminEmail?: string;
    isSharedGroup: boolean;
};

export type UpdateGroupRequest = {
    aagKey: number;
    name: string;
    description?: string;
    groupAdminEmail?: string;
};

export type AddGroupMemberRequest = {
    aagKey: number;
    imKey: number;
};

export type AddGroupMemberResponse = {
    admin: AssessmentAdmin;
    oldAdminGroup: AssessmentAdminGroup | null;
};

export type AssessmentQualification = {
    aqKey: number;
    imKey: number;
    qualification: string;
    createdDateTime?: string;
    modifiedDateTime?: string;
};
